import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import {
	PORTFOLIO_CONTRACT_STATE,
	type PortfolioContractStateKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import { FlatRowFormRadio } from "web_myplann/Shared/Components/FlatRow/FlatRowFormRadio";

const CONTRACT_STATE_OPTIONS: PortfolioContractStateKey[] = [
	PORTFOLIO_CONTRACT_STATE.all,
	PORTFOLIO_CONTRACT_STATE.archived,
];

type Props = {
	control: Control<FilterFormValues>;
};

export const ContractStateSection = ({ control }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<>
			<Typography
				variant="overline"
				display="block"
				pt={2.4}
				px={theme.spacingTokens.lg}
				pb={theme.spacingTokens.sm}
			>
				{t(Resources.Portfolio.List.Redesign.ContractState.label)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormRadio
					control={control}
					name="contractState"
					options={CONTRACT_STATE_OPTIONS.map((option) => ({
						value: option,
						label: t(Resources.Portfolio.List.Redesign.ContractState[option]),
					}))}
				/>
			</Stack>
		</>
	);
};
